export const fixKey = (key?: string): string => (key ? key : "");
